export const _getSharedFolderForm = (state, action) => action.payload;

export const _setIsNewSharedFolder = (state, action) => {
  state.item.isNewSharedFolder = action.payload;
};
